module.exports = __webpack_public_path__ + "media/images/icons/telegram_black-41a01d3922eb6ba7bbd7baf62121c724.svg";